import { AudienceInputTemplate } from 'feature/editorial-dash/templates/audience-input-template';
import { CommentSliderTemplate } from 'feature/editorial-dash/templates/comment-slider-template';
import { ConversationHelperTemplate } from 'feature/editorial-dash/templates/conversation-helper-template';
import { DialogueTemplate } from 'feature/editorial-dash/templates/dialogue-template';
import { RepresentingPerspectivesTemplate } from 'feature/editorial-dash/templates/representing-perspectives-template';
import type { QuestionConfig } from 'structure/question';
import type { Feature } from 'util/stdtypes';

export const StandardTemplates: Feature<QuestionConfig, {}> = {
    key: 'standard_templates',
    name: 'Standard Templates',
    dev: true,
    providesConfig: {
        questionFormatTemplates: [
            RepresentingPerspectivesTemplate,
            CommentSliderTemplate,
            DialogueTemplate,
            ConversationHelperTemplate,
            AudienceInputTemplate,
        ],
    },
};
